<template>
  <vx-card no-shadow>
    <div>
      <a href="#" @click="$emit('changeTab','Billing')">
        <h4 class="title-report font-semibold">Billing</h4>
      </a>
      <p class="text-base font-medium">Select type theme , firm logo , description.</p>
    </div>
    <div>
      <a href="#" @click="$emit('changeTab','TaxSetting')">
        <h4 class="title-report font-semibold">Tax Setting</h4>
      </a>
      <p class="text-base font-medium">Change your tax rate and type</p>
    </div>
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','DataEscrow')">-->
<!--        <h4 class="title-report font-semibold">Data Escrow</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium	">Manage back-ups using Amazon S3 cloud storage.</p>-->
<!--    </div>-->
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','FirmFeed')">-->
<!--        <h4 class="title-report font-semibold">Firm Feed</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">-->
<!--        Manage your Firm Feed's visibility.-->
<!--      </p>-->
<!--    </div>-->
<!--    <div>-->
<!--      <a href="#" @click="$emit('changeTab','ConnectSharing')">-->
<!--        <h4 class="title-report font-semibold">Lexi Connect & Sharing</h4>-->
<!--      </a>-->
<!--      <p class="text-base font-medium">-->
<!--        Edit branding options for Clio Connect and email notifications.-->
<!--        Manage your Clio Connect resources and bill preview settings.-->
<!--      </p>-->
<!--    </div>-->
  </vx-card>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>


<style>
  .title-report{
    transition: -webkit-transform 0.25s ease;
    transform: translateX(0px);
  }
  .title-report:hover{
    transition: -webkit-transform 0.25s ease;
    transform: translateX(5px);
  }
</style>
